var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"q10__page my-14"},[_c('div',{staticClass:"container px-11 2xl:px-3 m-auto"},[_c('div',{staticClass:"q10__article_container__title_head m-4"},[_c('article-title-tour',{attrs:{"options":{
                    tourtitle: _vm.currentPage.content.oTitleTour_tourtitle.text,
                    titlecolor: 'text-selective_yellow',
                    toursubtitle: _vm.currentPage.content.oTitleTour_toursubtitle.text,
                    subtitlecolor: 'text-nandor',
                }}})],1),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"relative  break-inside-avoid text-center mx-auto "},[_c('image-with-descriptions',{attrs:{"options":{
                      image: 'pages/' +
                    _vm.currentPage.slug + '/' +
                    _vm.currentPage.images.image1.src,
                    position: 'pr-44',
                    }}}),_c('div',{staticClass:"flex justify-center"},[_c('TimelineTitle',{attrs:{"options":{
                        content:
                            _vm.currentPage.images.image1.edf,
                        position: '-ml-10',

                        fontSize: {
                            content: 'text-md md:text-xl lg:text-base',
                        },
                        color: {
                            content: 'text-nandor',
                        },


                    }}}),_c('span',{staticClass:"q10__copyright",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.oCard2_sOuterText.text)}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('hotspot-richmedia',{staticClass:"-top-0 -right-2 md:-right-4 lg:-right-2",attrs:{"options":{
                    icon: 'diaporama',
                    collection : _vm.getRichmediaByCollection(_vm.currentPage, 'Création du CIH, témoignage de C. Perrier' ),
                }}}),_c('TimelineTitle',{attrs:{"options":{
                        year: _vm.currentPage.content.oCard2_sYear.text,
                        toptitle: _vm.currentPage.content.oCard2_sTopTitle.text,
                        pretitle: _vm.currentPage.content.oCard2_sPreTitle.text,
                        title: _vm.currentPage.content.oCard2_sTitle.text,
                        content: _vm.currentPage.content.oCard2_sText.text,

                        color: {
                            year: 'text-selective_orange',
                            pretitle: 'text-selective_yellow',
                            title: 'text-selective_yellow',
                            content: 'text-nandor',
                        },
                        fontSize: {
                            year: 'text-md md:text-lg lg:text-xl',
                            toptitle: 'text-md md:text-xl lg:text-2xl',
                            pretitle: 'text-2xl md:text-2xl lg:text-4xl',
                            title: 'text-4xl md:text-3xl lg:text-7xl',
                            content: 'text-md md:text-xl lg:text-base',
                            outerText: 'text-md',
                        },
                    }}})],1),_c('div',{staticClass:"card  break-inside-avoid"},[_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"w-full"},[_c('TimelineTitle',{attrs:{"options":{
                                year: _vm.currentPage.content.oCard3_sYear.text,
                                pretitle:
                                    _vm.currentPage.content.oCard3_sTopTitle.text,
                                title: _vm.currentPage.content.oCard3_sTitle.text,
                                subtitle:
                                    _vm.currentPage.content.oCard3_sSubTitle.text,
                                content:
                                    _vm.currentPage.content.oCard3.text,
                                outerText:
                                    _vm.currentPage.content.oCard3_sOuterText,
                                color: {
                                    year: 'text-selective_orange',
                                    title: 'text-selective_yellow',
                                    subtitle: 'text-selective_yellow',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    year: 'text-md md:text-lg lg:text-xl',
                                    pretitle:
                                        'text-2xl md:text-2xl lg:text-3xl',
                                    title: 'text-3xl md:text-3xl lg:text-5xl xl:text-4xl',
                                    subtitle:
                                        'text-2xl md:text-2xl lg:text-3xl',
                                    content:
                                        'text-md md:text-xl lg:text-base',
                                },
                            }}})],1),_c('div',{staticClass:"w-2/3 lg:mx-auto lg:w-2/5"},[_c('image-with-descriptions',{attrs:{"options":{
                               image: 'pages/' +
                                _vm.currentPage.slug + '/' +
                                _vm.currentPage.images.image2.src,
                            }}})],1)])]),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"\n                            container-timeline-title-si-image-with-description\n                            relative\n                            w-full\n                        "},[_c('div',{staticClass:"relative top-0 left-0 w-full lg:mx-auto"},[_c('image-with-descriptions',{attrs:{"options":{
                                    image: 'pages/' +
                                    _vm.currentPage.slug + '/' +
                                    _vm.currentPage.images.image3.src,
                                    descriptions: [
                                        {
                                            text: _vm.currentPage.images.image3.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            fontSize: 'text-sm md:text-base',
                                        } ],
                                }}}),_c('div',{staticClass:"custom_padding_top absolute top-0 left-0 p-5"},[_c('TimelineTitle',{attrs:{"options":{
                                    year: _vm.currentPage.content.oCard4_sYear.text,
                                    pretitle:
                                        _vm.currentPage.content.oCard4_sPreTitle.text,
                                    title: _vm.currentPage.content.oCard4_s1Title.text,
                                    subtitle:
                                        _vm.currentPage.content.oCard4_sSubTitle.text,

                                    fontSize: {
                                        year: 'text-md md:text-lg lg:text-xl',
                                        pretitle: 'text-xl 2xl:text-xl',
                                        title: 'text-4xl 2xl:text-6xl',
                                        subtitle: 'text-xl 2xl:text-xl',
                                        content:
                                            'text-md md:text-xl lg:text-base',
                                    },
                                    color: {
                                        year: 'text-selective_yellow',
                                        pretitle: 'text-white',
                                        title: 'text-white',
                                        subtitle: 'text-white',
                                        content: 'text-white',
                                    },
                                }}})],1)],1)])]),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                        content: _vm.currentPage.content.oCard4_sText.text,

                        fontSize: {},
                        color: {
                            year: 'text-selective_yellow',
                            pretitle: 'text-white',
                            title: 'text-nandor',
                            content: 'text-nandor',
                        },
                        position: {
                            bgContent: 'pt-0'
                        }
                    }}}),_c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"\n                            rounded-circle\n                            flex\n                            justify-center\n                            items-center\n                            text-start\n                            w-full\n                            md:w-3/4\n                            lg:w-full\n                            rounded-full\n                            bg-selective_yellow\n                            p-20\n                            mt-5\n                        "},[_c('TimelineTitle',{attrs:{"options":{
                                toptitle:
                                    _vm.currentPage.content.oCard4_s2TopTitle.text,
                                pretitle:
                                    _vm.currentPage.content.oCard4_s2PreTitle.text,
                                title: _vm.currentPage.content.oCard4_s2Title.text,
                                year: _vm.currentPage.content.oCard4_sYear.text,

                                fontSize: {
                                    year: 'text-md md:text-xl lg:text-xl',
                                    toptitle:
                                        'text-2xl md:text-2xl lg:text-2xl',
                                    pretitle:
                                        'text-2xl md:text-5xl lg:text-5xl',
                                    title: 'text-6xl md:text-6xl lg:text-6xl',
                                    subtitle:
                                        'text-xl md:text-2xl lg:text-2xl',
                                    content:
                                        'text-md md:text-xl lg:text-base',
                                },
                                color: {
                                    year: 'text-red-500',
                                    toptitle: 'text-white',
                                    pretitle: 'text-white',
                                    title: 'text-white',
                                    content: 'text-white',
                                },
                            }}})],1)])],1),_c('div',{staticClass:"\n                    container-timeline-title-si-image-with-description-second-1\n                    relative\n                    card  break-inside-avoid\n                "},[_c('hotspot-richmedia',{staticClass:"-top-0 -right-2",attrs:{"options":{
                    icon: 'diaporama',
                    collection : _vm.getRichmediaByCollection(_vm.currentPage, 'Évolution de l’organisation du CIH en 2003' ), 
                }}}),_c('div',{staticClass:"relative mx-auto lg:w-full lg:h-full xl:w-full xl:h-full"},[_c('image-with-descriptions',{attrs:{"options":{
                            image: 'pages/' +
                            _vm.currentPage.slug + '/' +
                            _vm.currentPage.images.image4.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image4.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                    fontSize: 'text-sm md:text-base',
                                } ],
                        }}}),_c('div',{staticClass:"absolute top-0 right-0 bottom-0 left-0 m-auto mt-8 sm:mt-0 xl:mt-0 2xl:mt-0 p-2 lg:pt-20 xl:p-2 xl:pt-7 2xl:p-4 2xl:pt-14"},[_c('TimelineTitle',{attrs:{"options":{
                            year: _vm.currentPage.content.oCard5_sYear.text,
                            pretitle: _vm.currentPage.content.oCard5_sPreTitle.text,
                            title: _vm.currentPage.content.oCard5_sTitle.text,
                            subtitle: _vm.currentPage.content.oCard5_sSubTitle.text,
                            content: _vm.currentPage.content.oCard5_sText.text,

                            fontSize: {
                                pretitle: 'text-sm md:text-xl lg:text-xl xl:text-lg 2xl:text-2xl',
                                year: 'text-base md:text-lg lg:text-md xl:text-lg 2xl:text-xl',
                                title: 'text-2xl md:text-3xl lg:text-5xl xl:text-4xl 2xl:text-8xl',
                                subtitle:
                                    'text-base md:text-xl lg:text-2xl xl:text-2xl 2xl:text-4xl',
                                content: 'text-xs md:text-sm lg:text-lg xl:text-md 2xl:text-lg',
                            },
                            color: {
                                year: 'text-red-500',
                                pretitle: 'text-white',
                                title: 'text-white',
                                subtitle: 'text-white',
                                content: 'text-white',
                            },
                        }}})],1)],1)],1),_c('div',{staticClass:"\n                    container-timeline-title-si-image-with-description-second-2\n                    card  break-inside-avoid\n                "},[_c('div',{staticClass:"relative w-full h-full"},[_c('image-with-descriptions',{attrs:{"options":{
                            image500: 'pages/' +
                            _vm.currentPage.slug + '/' +
                            _vm.currentPage.images.image5.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image5.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                    fontSize: 'text-base',
                                } ],
                        }}})],1),_c('div',{staticClass:"absolute top-0 left-0 p-10"},[_c('TimelineTitle',{attrs:{"options":{
                            year: _vm.currentPage.content.oCard6_sYear.text,
                            pretitle: _vm.currentPage.content.oCard6_sPreTitle.text,
                            title: _vm.currentPage.content.oCard6_sTitle.text,
                            content: _vm.currentPage.content.oCard6_sText.text,

                            fontSize: {
                                year: 'text-md md:text-lg lg:text-xl',
                                pretitle:
                                    'text-2xl md:text-2xl lg:text-3xl',
                                title: 'text-4xl md:text-3xl lg:text-7xl',
                                content: 'text-md md:text-xl lg:text-base',
                            },
                            color: {
                                year: 'text-selective_yellow',
                                pretitle: 'text-white',
                                title: 'text-white',
                                content: 'text-white',
                            },
                        }}})],1)]),_c('div',{staticClass:"card  break-inside-avoid"},[_c('hotspot-richmedia',{staticClass:"-top-0 -right-2",attrs:{"options":{
                    icon: 'diaporama',
                    collection : _vm.getRichmediaByCollection(_vm.currentPage, 'Première université de printemps 2003' ),
                }}}),_c('div',{staticClass:"\n                        container-timeline-title-si-image-with-description-second-3\n                        relativ\n                        flex flex-col                         "},[_c('TimelineTitle',{attrs:{"options":{
                                year: _vm.currentPage.content.oCard7_sYear.text,
                                title: _vm.currentPage.content.oCard7_sTitle.text,
                                precontent:
                                    _vm.currentPage.content.oCard7_sMainText.text,
                                content: _vm.currentPage.content.oCard7_sText.text,

                                fontSize: {
                                    year: 'text-md md:text-xl lg:text-2xl pl-4 pt-4',
                                    title: 'text-2xl md:text-3xl lg:text-3xl p-4',
                                    precontent:
                                        'font-bold text-4xl md:text-4xl lg:text-6xl',
                                    content:
                                        'text-md md:text-xl lg:text-base pr-5 pb-3',
                                },
                                color: {
                                    year: 'text-selective_orange',
                                    pretitle: 'text-white',
                                    title: 'text-white',
                                    precontent: 'text-white',
                                    content: 'text-white',
                                    bgContent : 'bg-selective_yellow'
                                },
                            }},scopedSlots:_vm._u([{key:"top_outside",fn:function(){return [_c('image-with-descriptions',{staticClass:"-mb-4",attrs:{"options":{
                                image: 'pages/' +
                                _vm.currentPage.slug + '/' +
                                _vm.currentPage.images.image6.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image6.text,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-base',
                                    } ],
                            }}})]},proxy:true}])})],1)],1)])]),_c('timeline-carousel',{attrs:{"options":{
        timeline: _vm.currentPage.timeline
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }